export class ConfigNavigationConstants {
    static readonly QA_CONFIG_ACTION_ACCESS = [
        {
            code: 'AccountInquiryFulfillment',
            parentCode: 'CONFIGURATION_CLOSING_PORTAL',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Closing Portal Configurations - Account Inquiry Fulfillment'
        },
        {
            code: 'CiraConnectFee',
            parentCode: 'CONFIGURATION_CLOSING_PORTAL',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Closing Portal Configurations - CiraConnect Fee'
        },
        {
            code: 'ConveyanceFeeCharge',
            parentCode: 'CONFIGURATION_CLOSING_PORTAL',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Closing Portal Configurations - Portal Configuration Fees & Charges'
        },
        {
            code: 'Amenity',
            parentCode: 'CONFIGURATION_COMMUNITY',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Configurations  - Amenity'
        },
        {
            code: 'FJSPC',
            parentCode: 'CONFIGURATION_COMMUNITY',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Configurations - Fulfillment Job Special Pricing Configuration'
        },
        {
            code: 'MassCommunicationConfiguration',
            parentCode: 'CONFIGURATION_COMMUNITY',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Configurations - Mass Communication Configuration'
        },
        {
            code: 'Notes',
            parentCode: 'CONFIGURATION_COMMUNITY',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Configurations - Notes'
        },
        {
            code: 'PrintingProvider',
            parentCode: 'CONFIGURATION_COMMUNITY',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Configurations - Printing Provider'
        },
        {
            code: 'WelcomeLetter',
            parentCode: 'CONFIGURATION_COMMUNITY',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Configurations - Welcome Letter Config'
        },
        {
            code: 'CrossEntityAPBillConfiguration',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - AAP Cross Entity Bill'
        },
        {
            code: 'AAPWFAutoActionConfiguration',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - AAP Work Flow Auto Action'
        },
        {
            code: 'AAPWFConfiguration',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - AAP Work Flow CheckList'
        },
        {
            code: 'BillingTypes',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - AAR Billing Types'
        },
        {
            code: 'BuilderConfiguration',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - AAR Builder Statements'
        },
        {
            code: 'MISCINVOICETYPECONFIGURATIONS',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - AAR Misc Invoice Types'
        },
        {
            code: 'PaymentApplicationOrder',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - AAR Payment Application Order'
        },
        {
            code: 'Statements',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - Statements'
        },
        {
            code: 'CollectionsConfiguration',
            parentCode: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Community Accounting Configurations - Collections Configuration'
        },
        {
            code: 'AccCategories',
            parentCode: 'CONFIGURATION_ENFORCEMENT',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Enforcement Configurations - Architectural Categories'
        },
        {
            code: 'ACC_FORMS',
            parentCode: 'CONFIGURATION_ENFORCEMENT',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Enforcement Configurations - Architectural Forms and Guides'
        },
        {
            code: 'EntityConfiguration',
            parentCode: 'CONFIGURATION_MODULES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Modules Configurations - Customer Defined Info'
        },
        {
            code: 'Egnyte',
            parentCode: 'CONFIGURATION_MODULES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Modules Configurations - Egnyte Configuration'
        },
        {
            code: 'Help',
            parentCode: 'CONFIGURATION_MODULES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Modules Configurations - Help Configuration'
        },
        {
            code: 'RecommendationsAssumptions',
            parentCode: 'CONFIGURATION_MODULES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Modules Configurations - Recommendations and Assumptions'
        },
        {
            code: 'SupplementalInformation',
            parentCode: 'CONFIGURATION_MODULES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Modules Configurations - Supplemental Information'
        },
        {
            code: 'TransitionDocument',
            parentCode: 'CONFIGURATION_MODULES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Modules Configurations - Transition Document'
        },
        {
            code: 'TransitionTaskTemplates',
            parentCode: 'CONFIGURATION_MODULES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Modules Configurations - Transition Task Templates'
        },
        {
            code: 'WorkOrderWorkAreas',
            parentCode: 'CONFIGURATION_MODULES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Modules Configurations - Work Order Work Areas'
        },
        {
            code: 'COMMUNITY_AUTO_CLOSE_REPORT_GEN',
            parentCode: 'CONFIGURATION_PROCESS_TRACKER',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Process Tracker Configurations - Community Auto Close & Report Generation'
        },
        {
            code: 'FinancialPackageConfiguration',
            parentCode: 'CONFIGURATION_PROCESS_TRACKER',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Process Tracker Configurations - Financial Package Configuration'
        },
        {
            code: 'Process Tracker Step Auto Completion',
            parentCode: 'CONFIGURATION_PROCESS_TRACKER',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Process Tracker Configurations - Process Tracker Configuration'
        },
        {
            code: 'Letter Templates',
            parentCode: 'CONFIGURATION_REPORT_TEMPLATE',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Report Templates Configurations - Letter Templates'
        },
        {
            code: 'Letterhead Template',
            parentCode: 'CONFIGURATION_REPORT_TEMPLATE',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Report Templates Configurations - Letterhead Templates'
        },
        {
            code: 'BoardPortal',
            parentCode: 'CONFIGURATION_SERVICES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Services Configurations - Board Portal'
        },
        {
            code: 'BrandingConfiguration',
            parentCode: 'CONFIGURATION_SERVICES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Services Configurations - Branding Configuration'
        },
        {
            code: 'AssociationCalendarLabelTypeConfiguration',
            parentCode: 'CONFIGURATION_SERVICES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Services Configurations - Calendar Configuration'
        },
        {
            code: 'ResidentPortal',
            parentCode: 'CONFIGURATION_SERVICES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Services Configurations - Resident Portal'
        },
        {
            code: 'ServiceGroups',
            parentCode: 'CONFIGURATION_SERVICES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Services Configurations - Service Groups'
        },
        {
            code: 'ServiceRoles',
            parentCode: 'CONFIGURATION_SERVICES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Services Configurations - Service Roles'
        },
        {
            code: 'Services',
            parentCode: 'CONFIGURATION_SERVICES',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Services Configurations - Services'
        }
    ];
}
